<template>
	<div>
		<v-expansion-panel
			class="expansion"
		>
			<v-expansion-panel-content
				v-for="(item, i) in templates"
				:key="i"
			>
				<template slot="header" tag="div">
					<div class="wrapper-header">
						<div class="panel-title"
							:style="`color:${$appColors.primary}`"
						>{{item.name}}</div>
						<button
							type="button"
							class="panel-selection-btn"
							:style="`background-color:${$appColors.primary}`"
							@click.stop="selecting(item)"
						>Seleccionar</button>
					</div>
				</template>
				<div class="templates-images">
					<img :src="item.urlImage.web" alt="">
				</div>
			</v-expansion-panel-content>
    	</v-expansion-panel>
	</div>
</template>
<script>

function selecting(template) {
	this.$store.dispatch('tool/selectTemplate', template);
	this.showNotification(`Plantilla: "${template.name}" seleccionada`, 'success');
	this.goTo('new-tool');
}

export default {
	name: 'template-tools',
	methods: {
		selecting,
	},
	props: {
		templates: {
			type: Array,
			required: true,
		},
	},
};
</script>
<style lang="scss" scoped>
.expansion {
	
	.v-expansion-panel__container {
		background-color: color(border-gray);
		border-top: none;
		margin-bottom: 5px;
	}

	.wrapper-header {
		align-items: center;
		display: flex;
		justify-content: space-between;

		.panel-title {
			font-family: font(bold);
			font-size: size(medium);
		}

		.panel-selection-btn {
			border-radius: 4px;
			color: white;
			margin-right: 10px;
			padding: 5px 10px;
		}
	}

}

.templates-images {
	align-items: center;
	background-color: white;
	display: flex;
	justify-content: center;
	padding: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/tools/template-tools.vue